/* vl-popup (2026-10-02): email-only capture popup (no discount, no code). No dependencies, no third-party requests.
   Opens ~8 s after load, or on desktop exit intent; once per visitor (14 days via localStorage, cookie fallback, in-memory last resort).
   Never on /cart or /checkout. Closes on x, "No thanks", Esc and backdrop. Focus is trapped while open and restored on close.
   Submit goes through the native Shopify customer form ({% form 'customer' %}); fetch is only used to avoid a page reload,
   and anything unexpected (captcha challenge, network error) falls back to a normal form submit.
   Preview toggles: ?vlp=1 (form step), ?vlp=success (success step) - neither writes the "seen" flag. */
(function () {
  'use strict';

  var root = document.getElementById('vlp');
  if (!root || root.__vlpReady) return;
  root.__vlpReady = true;

  var KEY = 'vlp_v1';
  var SEEN_DAYS = 14;      /* closed or shown: do not show again for 14 days */
  var DONE_DAYS = 180;     /* subscribed: stay quiet much longer */
  var DELAY_MS = 8000;     /* timed trigger */
  var EXIT_MIN_MS = 3000;  /* exit intent only after this long on the page */
  var DAY = 864e5;

  var dialog = root.querySelector('.vlp-dialog');
  var form = root.querySelector('form');
  var input = root.querySelector('#vlp-email');
  var errorEl = root.querySelector('#vlp-error');
  var submitBtn = root.querySelector('[data-vlp-submit]');
  var stepForm = root.querySelector('[data-vlp-step="form"]');
  var stepDone = root.querySelector('[data-vlp-step="done"]');
  var doneTitle = root.querySelector('#vlp-title-done');
  if (!dialog || !form || !input || !stepForm || !stepDone) return;

  var opened = false;
  var lastFocus = null;
  var closeTimer = null;
  var openTimer = null;
  var retries = 0;
  var startTs = Date.now();
  var memory = null;
  var reduceMotion = false;
  try { reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches; } catch (e) {}

  /* ---------- storage: localStorage, then cookie, then memory ---------- */
  function readFlag() {
    try {
      var v = window.localStorage.getItem(KEY);
      if (v) return JSON.parse(v);
    } catch (e) {}
    try {
      var m = document.cookie.match(/(?:^|;\s*)vlp_v1=([^;]*)/);
      if (m) return JSON.parse(decodeURIComponent(m[1]));
    } catch (e) {}
    return memory;
  }
  function writeFlag(obj) {
    memory = obj;
    var s = JSON.stringify(obj);
    try {
      window.localStorage.setItem(KEY, s);
      return;
    } catch (e) {}
    try {
      document.cookie = 'vlp_v1=' + encodeURIComponent(s) + '; max-age=' + ((obj.done ? DONE_DAYS : SEEN_DAYS) * 86400) + '; path=/; SameSite=Lax';
    } catch (e) {}
  }
  function suppressed() {
    var r = readFlag();
    if (!r || !r.t) return false;
    return Date.now() - r.t < (r.done ? DONE_DAYS : SEEN_DAYS) * DAY;
  }

  function blockedPath() {
    return /(^|\/)(cart|checkouts?)(\/|$)/.test(window.location.pathname);
  }

  /* ---------- URL state ---------- */
  var qs = null;
  try { qs = new URLSearchParams(window.location.search); } catch (e) {}
  var force = qs ? qs.get('vlp') : null;
  var posted = !!root.querySelector('[data-vlp-posted]') ||
    (qs && qs.get('customer_posted') === 'true' && window.location.hash === '#vlp-form');

  function cleanUrl() {
    try {
      if (!qs) return;
      qs.delete('customer_posted');
      var q = qs.toString();
      window.history.replaceState(null, '', window.location.pathname + (q ? '?' + q : ''));
    } catch (e) {}
  }

  /* ---------- steps ---------- */
  function showStep(step) {
    var done = step === 'done';
    stepForm.hidden = done;
    stepDone.hidden = !done;
    dialog.setAttribute('aria-labelledby', done ? 'vlp-title-done' : 'vlp-title');
  }

  function focusables() {
    var nodes = dialog.querySelectorAll('a[href],button:not([disabled]),input:not([disabled]):not([type="hidden"]),select,textarea,[tabindex]:not([tabindex="-1"])');
    return Array.prototype.filter.call(nodes, function (n) {
      return n.offsetWidth || n.offsetHeight || n.getClientRects().length;
    });
  }

  function onKey(e) {
    if (e.key === 'Escape' || e.key === 'Esc') {
      e.preventDefault();
      e.stopPropagation();
      close();
      return;
    }
    if (e.key !== 'Tab') return;
    var list = focusables();
    if (!list.length) {
      e.preventDefault();
      dialog.focus();
      return;
    }
    var first = list[0];
    var last = list[list.length - 1];
    var a = document.activeElement;
    if (e.shiftKey) {
      if (a === first || a === dialog || !dialog.contains(a)) {
        e.preventDefault();
        last.focus();
      }
    } else if (a === last || !dialog.contains(a)) {
      e.preventDefault();
      first.focus();
    }
  }

  function warmImage() {
    var img = root.querySelector('.vlp-media img');
    if (img && img.loading === 'lazy') img.loading = 'eager'; /* starts the download now, the panel is hidden until open */
  }

  function open(step, silent) {
    if (opened) return;
    opened = true;
    warmImage();
    if (closeTimer) { clearTimeout(closeTimer); closeTimer = null; }
    lastFocus = document.activeElement;
    showStep(step || 'form');
    root.hidden = false;
    document.documentElement.classList.add('vlp-lock');
    void root.offsetWidth; /* reflow so the slide-in transition runs */
    root.classList.add('vlp-in');
    document.addEventListener('keydown', onKey, true);
    try { (step === 'done' ? doneTitle : dialog).focus({ preventScroll: true }); } catch (e) {}
    if (!silent) writeFlag({ t: Date.now(), done: step === 'done' });
  }

  function close() {
    if (!opened) return;
    opened = false;
    root.classList.remove('vlp-in');
    document.removeEventListener('keydown', onKey, true);
    document.documentElement.classList.remove('vlp-lock');
    var finish = function () { root.hidden = true; closeTimer = null; };
    if (reduceMotion) finish(); else closeTimer = setTimeout(finish, 280);
    if (lastFocus && lastFocus !== document.body && document.contains(lastFocus) && typeof lastFocus.focus === 'function') {
      try { lastFocus.focus({ preventScroll: true }); } catch (e) {}
    }
  }

  /* ---------- triggers ---------- */
  function otherDialogOpen() {
    if (document.querySelector('dialog[open]')) return true;
    var a = document.activeElement;
    return !!(a && !root.contains(a) && /^(INPUT|TEXTAREA|SELECT)$/.test(a.tagName));
  }

  function tryOpen() {
    if (opened || suppressed() || blockedPath()) return;
    if (document.visibilityState === 'hidden') {
      document.addEventListener('visibilitychange', function onVis() {
        if (document.visibilityState === 'visible') {
          document.removeEventListener('visibilitychange', onVis);
          tryOpen();
        }
      });
      return;
    }
    if (otherDialogOpen()) {
      if (retries++ < 4) openTimer = setTimeout(tryOpen, 4000);
      return;
    }
    open('form');
  }

  /* ---------- form ---------- */
  function setBusy(on) {
    submitBtn.disabled = on;
    submitBtn.textContent = on ? 'Sending...' : 'Sign me up';
    form.setAttribute('aria-busy', on ? 'true' : 'false');
  }
  function showError(msg) {
    errorEl.textContent = msg;
    errorEl.hidden = false;
    input.setAttribute('aria-invalid', 'true');
    try { input.focus(); } catch (e) {}
  }
  function clearError() {
    errorEl.hidden = true;
    errorEl.textContent = '';
    input.removeAttribute('aria-invalid');
  }
  function onSuccess() {
    writeFlag({ t: Date.now(), done: true });
    setBusy(false);
    showStep('done');
    try { doneTitle.focus({ preventScroll: true }); } catch (e) {}
  }
  function nativeSubmit() {
    form.__vlpNative = true;
    try { HTMLFormElement.prototype.submit.call(form); } catch (e) { try { form.submit(); } catch (e2) {} }
  }

  form.addEventListener('input', function () { if (!errorEl.hidden) clearError(); });
  form.addEventListener('submit', function (e) {
    if (form.__vlpNative) return;
    var v = (input.value || '').trim();
    if (!/^[^\s@]+@[^\s@]+\.[^\s@]{2,}$/.test(v)) {
      e.preventDefault();
      showError('Please enter a valid email address.');
      return;
    }
    clearError();
    if (!window.fetch || !window.FormData) return; /* plain submit */
    e.preventDefault();
    setBusy(true);
    fetch(form.getAttribute('action') || '/contact', {
      method: 'POST',
      body: new FormData(form),
      credentials: 'same-origin',
      headers: { 'Accept': 'text/html' }
    }).then(function (res) {
      if (/[?&]customer_posted=true/.test(res.url || '')) onSuccess();
      else nativeSubmit(); /* e.g. captcha challenge: let the normal page flow handle it */
    }).catch(function () {
      nativeSubmit();
    });
  });

  /* ---------- close controls ---------- */
  root.addEventListener('click', function (e) {
    var t = e.target;
    if (t && t.closest && t.closest('[data-vlp-close]')) close();
  });

  /* ---------- init ---------- */
  if (posted) {
    open('done');
    cleanUrl();
  } else if (force === 'success') {
    open('done', true);
  } else if (force === '1' || force === 'show') {
    open('form', true);
  } else if (!errorEl.hidden) {
    open('form'); /* server-side error after a native submit */
  } else if (!suppressed() && !blockedPath()) {
    openTimer = setTimeout(tryOpen, DELAY_MS);
    setTimeout(warmImage, Math.max(0, DELAY_MS - 3000));
    var fine = false;
    try { fine = window.matchMedia('(hover: hover) and (pointer: fine)').matches; } catch (e) {}
    if (fine) {
      document.addEventListener('mouseout', function (e) {
        if (e.relatedTarget === null && e.clientY <= 0 && window.innerWidth >= 750 && Date.now() - startTs > EXIT_MIN_MS) tryOpen();
      });
    }
  }
})();
